// ─── Fiche INFO d'une note de journal (lecture seule) ─────────────
// Règle app-wide : un clic sur une ligne de liste OUVRE LA FICHE, jamais
// l'éditeur — l'édition passe par le ✏️ d'en-tête ou le swipe droit. Même
// gabarit que FicheLieuInfo / FicheContactInfo pour que tout se lise pareil.
// (MoPCal n'avait pas de fiche : le tap ne faisait rien et `modifierNote`
// n'était appelée nulle part — l'édition d'une note n'existait pas.)
import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Feuille, useUI, useT, frJMA } from '@mop/core';
import { labelNature, labelValeur, emojiNote, natureDe } from './data/journal';

export default function FicheNoteInfo({ visible, note, auteur, onFermer, onEditer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const n = note || {};
  const valeur = labelValeur(n, t);

  return (
    <Feuille
      visible={visible}
      titre={frJMA(n.date) || t('journal.titre')}
      emoji={emojiNote(n)}
      hauteur={0.7}
      onFermer={onFermer}
      action={{ icone: '✏️', label: t('commun.editer'), onPress: onEditer }}
    >
      <Text style={s.lbl}>{t('journal.nature')}</Text>
      <View style={s.row}>
        <Text style={s.val}>{labelNature(natureDe(n), t)}</Text>
      </View>

      {/* La valeur n'est affichée QUE si elle existe : une note sans valeur
          est un cas normal, et une ligne vide serait du bruit. */}
      {!!valeur && (
        <>
          <Text style={s.lbl}>{t(`journal.valeur_${natureDe(n)}`)}</Text>
          <View style={s.row}><Text style={s.val}>{valeur}</Text></View>
        </>
      )}

      <Text style={s.lbl}>{t('journal.texte')}</Text>
      <Text style={s.texte}>{n.texte || ''}</Text>

      {!!auteur && (
        <>
          <Text style={s.lbl}>{t('journal.auteur')}</Text>
          <View style={s.row}><Text style={s.val}>{auteur}</Text></View>
        </>
      )}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  lbl:   { fontSize: 12, color: UI.faint, fontWeight: '700', marginTop: 10, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.3 },
  row:   { flexDirection: 'row', alignItems: 'center', gap: 11, paddingVertical: 9, borderBottomWidth: 0.5, borderBottomColor: UI.border },
  val:   { flex: 1, fontSize: 14.5, color: UI.ink },
  texte: { fontSize: 14.5, color: UI.ink, lineHeight: 21, marginTop: 2 },
});
